import {createFeatureSelector, createSelector} from '@ngrx/store';
import {FEATURE_NAME, RuleState} from './rule.state';
import {RuleConverter} from '../converter/rule.converter';

export const selectRuleState = createFeatureSelector<RuleState>(FEATURE_NAME);

export const selectFilteredRulesWithCurrentPage = createSelector(
  selectRuleState,
  (state) => {
    if (state.filter?.page === null
      || state.filter?.page === undefined
      || !state.pages[state.filter!!.page!!]) {
      return [];
    }

    return state.pages[state.filter!!.page!!]
      .map((id) => RuleConverter.toViewModel(state.entities[id])) ?? []
  }
);

export const selectRuleById = (id: string) => createSelector(
  selectRuleState,
  (state: RuleState) => state.entities.hasOwnProperty(id)
    ? RuleConverter.toViewModel(state.entities[id])
    : null
);

export const selectRulesByDeviceId = (deviceId: string) => createSelector(
  selectRuleState,
  (state: RuleState) => Object.values(state.entities).filter((entity) => {
    const hasMatchingCondition = entity.conditions.some((condition) =>
      condition.sensorDevice?.id === deviceId);
    const hasMatchingAction = entity.actions.some((action) => action.device?.id === deviceId);

    return hasMatchingCondition || hasMatchingAction;
  }),
);

export const selectRulesByDeviceIdAsViewModel = (deviceId: string) => createSelector(
  selectRulesByDeviceId(deviceId),
  (rules) => rules.map((rule) => RuleConverter.toViewModel(rule)),
);

export const selectRulesByDeviceGroupId = (deviceGroupId: string) => createSelector(
  selectRuleState,
  (state: RuleState) => Object.values(state.entities).filter((entity) => {
    const hasMatchingAction = entity.actions.some((action) => action.deviceGroup?.id === deviceGroupId);

    return hasMatchingAction;
  }),
);

export const selectRulesByDeviceGroupIdAsViewModel = (deviceGroupId: string) => createSelector(
  selectRulesByDeviceGroupId(deviceGroupId),
  (rules) => rules.map((rule) => RuleConverter.toViewModel(rule)),
);

export const selectIsRulesLoading = createSelector(
  selectRuleState,
  (state) => state.isLoading
);

export const selectRulesTotalCount = createSelector(
  selectRuleState,
  (state) => state.totalCount
);

export const selectRuleFilter = createSelector(
  selectRuleState,
  (state) => state.filter
);

export const selectRuleByIdAsEditForm = (id: string) => createSelector(
  selectRuleState,
  (state: RuleState) => state.entities.hasOwnProperty(id)
    ? RuleConverter.toFormModel(state.entities[id])
    : null
);
